<script>
  // [05/23] https://tailwindui.com/components/application-ui/forms/select-menus
  import {
    Listbox,
    ListboxLabel,
    ListboxButton,
    ListboxOptions,
    ListboxOption,
    // Transition,
  } from '@rgossiaux/svelte-headlessui';
  import HiChevronUpDown from '../heroicons/HiChevronUpDown.svelte';

  export let value;
  export let label = undefined;
  export let elements;
  export let lang = undefined;
  export let cssClass = undefined;
  export let active = false;

  value = value !== undefined ? value : elements[0].value;

  function getLabel (label) {
    if (typeof label === 'string') return label;
    else return label[lang];
  }
</script>

<div class="tailwind select-menu {cssClass || ''}">
  <Listbox value={value} on:change={e => (value = e.detail)} let:open>
    {#if label}
      <ListboxLabel class="block text-sm font-medium leading-6 text-neutral-900 dark:text-white">
        {label}
      </ListboxLabel>
    {/if}

    <div class="relative {label ? 'mt-2' : ''}">
      <ListboxButton class="relative w-full cursor-default rounded-md py-1.5 pl-3 pr-10 text-left dark:text-white shadow-sm ring-inset ring-neutral-300 dark:ring-neutral-500 text-sm leading-6
        {active
          ? 'bg-blue-600 dark:bg-blue-500 font-semibold text-white hover:bg-blue-500 dark:hover:bg-blue-400 ring-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 dark:focus-visible:outline-blue-500'
          : 'bg-white dark:bg-neutral-800 text-neutral-900 ring-1 focus:outline-none focus:ring-2 focus:ring-blue-600 dark:focus:ring-blue-500'}">

        <span class="inline-flex w-full truncate">
          <span class="truncate">
            {getLabel(elements.find(e => e.value === value).label, lang)}
          </span>
          <span class="ml-2 truncate text-neutral-500 dark:text-neutral-400">
            {elements.find(e => e.value === value).append || ''}
          </span>
        </span>

        <span class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
          <HiChevronUpDown cssClass="h-5 w-5
            {active
              ? 'text-blue-200 dark:text-blue-200'
              : 'text-neutral-400 dark:text-neutral-500'}"/>
        </span>
      </ListboxButton>

      <!-- <Transition
        show={open}
        leave="transition ease-in duration-100"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"> -->

        <ListboxOptions class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white dark:bg-neutral-800 py-1 text-sm shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
          {#each elements as element (element.value)}
            <ListboxOption
              class={({ active }) =>
                `${active ? 'bg-blue-600 dark:bg-blue-500 text-white dark:text-white' : 'text-neutral-900 dark:text-white'} relative cursor-default select-none py-2 pl-3 pr-9`}
              value={element.value}
              let:selected
              let:active>

              <div class="flex">
                <span class={`${selected ? 'font-semibold' : 'font-normal'} truncate`}>
                  {getLabel(element.label, lang)}
                </span>
                <span class={`${active ? 'text-blue-200 dark:text-blue-200' : 'text-neutral-500 dark:text-neutral-400'} ml-2 truncate`}>
                  {element.append || ''}
                </span>
              </div>
            </ListboxOption>
          {/each}
        </ListboxOptions>
      <!-- </Transition> -->
    </div>
  </Listbox>
</div>
